var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import React from 'react';
export function RenderDebugTextFrame(component, index) {
    return (_jsx(DebugTextFrame, { component: component, index: index }));
}
export function RenderDebugTextFrameToggle(component, index) {
    return (_jsx(DebugTextFrameToggle, { component: component, index: index }));
}
var DebugTextFrameContext = React.createContext(null);
export function DebugTextFrame(props) {
    var _a, _b, _c, _d, _e;
    var _f = React.useState(false), codeVisible = _f[0], setCodeVisible = _f[1];
    var style = {
        border: (_a = props.component.properties.border) !== null && _a !== void 0 ? _a : "1px dotted darkgray",
        width: (_b = props.component.properties.width) !== null && _b !== void 0 ? _b : "calc(100% - 4em)",
        height: (_c = props.component.properties.height) !== null && _c !== void 0 ? _c : "100%",
        margin: (_d = props.component.properties.margin) !== null && _d !== void 0 ? _d : "1em",
        padding: (_e = props.component.properties.padding) !== null && _e !== void 0 ? _e : "1em",
    };
    if (codeVisible) {
        style.overflow = "auto";
    }
    return (_jsx("div", { style: style, children: _jsx(DebugTextFrameContext.Provider, { value: props.component, children: _jsx(Components.SimpleComponentContent, { component: props.component }) }) }));
}
export function DebugTextFrameToggle(props) {
    var _a = React.useState(false), codeVisible = _a[0], setCodeVisible = _a[1];
    var context = React.useContext(DebugTextFrameContext);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [codeVisible && _jsx(DebuxTextFrameCode, { component: context !== null && context !== void 0 ? context : props.component }), codeVisible || _jsx(Components.SimpleComponentContent, { component: props.component })] }), _jsx("div", { style: { textAlign: 'right' }, children: _jsx(Components.Button, { onClick: function () { return setCodeVisible(!codeVisible); }, children: "<>" }) })] }));
}
export function DebuxTextFrameCode(props) {
    var _a = React.useState(""), source = _a[0], setSource = _a[1];
    React.useEffect(function () {
        try {
            var componentsTonder = filterDebugComponents([props.component]);
            setSource(function () { return buildTsxForChildren(componentsTonder, ""); });
        }
        catch (err) {
            console.error(err);
        }
    }, [props.component]);
    function sourceUpdated(src) {
        setSource(src);
        try {
            var compoennt = Common.parseTsx(src, true);
            if (compoennt && props.componentChanged) {
                props.componentChanged(compoennt);
            }
        }
        catch (_a) {
        }
    }
    return _jsx(Components.SourceEditor, { source: source, setSource: sourceUpdated, allowEdit: props.editable });
}
function filterDebugComponents(components) {
    var _a, _b;
    if (!components) {
        return null;
    }
    var result = [];
    for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
        var component = components_1[_i];
        if (!component) {
            continue;
        }
        if (component.type === 'Text' && !((_a = component.properties) === null || _a === void 0 ? void 0 : _a.text) && !component.children) {
            continue;
        }
        if (component.type === 'DebugTextFrame' || component.type === 'DebugTextFrameToggle') {
            if ((_b = component.properties) === null || _b === void 0 ? void 0 : _b.text) {
                result.push({ type: "Text", properties: { text: component.properties.text } });
            }
            result.push.apply(result, filterDebugComponents(component.children));
        }
        else {
            var cmp = __assign(__assign({}, component), { children: filterDebugComponents(component.children) });
            result.push(cmp);
        }
    }
    return result;
}
function buildFilteredTsx(component, indent) {
    var _a, _b, _c;
    if (component.type === 'Text') {
        return "".concat(indent).concat((_a = component.properties) === null || _a === void 0 ? void 0 : _a.text);
    }
    var result = "".concat(indent, "<").concat(component.type);
    for (var key in component.properties) {
        if (key !== 'text') {
            result += " ".concat(key, "=\"").concat(component.properties[key], "\"");
        }
    }
    var hasContent = false;
    if ((_b = component.properties) === null || _b === void 0 ? void 0 : _b.text) {
        result += '>\n';
        hasContent = true;
        result += "".concat(indent, "    ").concat((_c = component.properties) === null || _c === void 0 ? void 0 : _c.text, "\n");
    }
    if (component.children && component.children.length > 0) {
        result += '>\n';
        hasContent = true;
        result += buildTsxForChildren(component.children, indent + '    ') + "\n";
    }
    if (hasContent) {
        result += "".concat(indent, "</").concat(component.type, ">");
    }
    else {
        result += ' />';
    }
    return result;
}
function buildTsxForChildren(children, indent) {
    return children.map(function (c) { return buildFilteredTsx(c, indent); }).join('\n');
}
